import Tracker from '@openreplay/tracker';

let tracker = null;

// Create a shared tracker instance
if (process.env.REACT_APP_STAGE === 'prod' && process.env.NODE_ENV === 'production') {
    tracker = new Tracker({
        projectKey: "RhzZMhVYBqkxuggEYKUy",
        ingestPoint: "https://openreplay.languify.in/ingest",
    });
}

const initOpenReplay = () => {
    if (tracker) tracker.start();
};

export { tracker, initOpenReplay };
